import mapValues from 'lodash-es/mapValues'

import { BirdviewSection } from '../DashboardBirdview.constants'
import {
  checkIsBirdviewDocFlowsViewable,
  getBirdviewSection,
  getBirdviewTiles,
} from '../DashboardBirdview.utils'

import {
  BIRDVIEW_OPERATIONAL_LAYOUT,
  BIRDVIEW_OPERATIONAL_TILES,
  BirdviewOperationalWidget,
} from './BirdviewOperational.constants'

export function getBirdviewOperationalLayout(sectionsPermissions) {
  return checkIsBirdviewDocFlowsViewable(sectionsPermissions)
    ? BIRDVIEW_OPERATIONAL_LAYOUT
    : mapValues(BIRDVIEW_OPERATIONAL_LAYOUT, column =>
        column.filter(widget => widget !== BirdviewOperationalWidget.DocFlows)
      )
}

export function getBirdviewOperationalSections(sections) {
  return {
    activities: getBirdviewSection(sections[BirdviewSection.Activities]),
    attention: getBirdviewSection(sections[BirdviewSection.Attention]),
    communication: getBirdviewSection(sections[BirdviewSection.Communication]),
    docFlows: getBirdviewSection(sections[BirdviewSection.DocFlows]),
    greta: getBirdviewSection(sections[BirdviewSection.Greta]),
    properties: getBirdviewSection(sections[BirdviewSection.Properties]),
    serviceRequests: getBirdviewSection(
      sections[BirdviewSection.ServiceRequests]
    ),
    tiles: getBirdviewTiles({
      definitions: BIRDVIEW_OPERATIONAL_TILES,
      sections,
    }),
  }
}
